import * as React from 'react';
import ChangeTheme from 'pages/settings/ChangeTheme';
import SettingsHeader from './SettingsHeader';
const Settings = ({ children, onClose }) => (React.createElement(SettingsHeader, { onClose: onClose },
    React.createElement(ChangeTheme, null),
    children));
export default Settings;
